<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0"><i class="fas fa-bolt"></i> Hajtások</h1>
      </div>
      <div class="ms-auto">
        <button
          v-if="user.role_id == 1"
          class="btn btn-success btn-rounded px-4 rounded-pill"
          v-b-modal.addPositionModal
        >
          <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új hajtás
        </button>
      </div>
    </div>
    <b-modal
      id="addPositionModal"
      cancel-variant="default"
      @cancel="closeAddModal()"
      @ok="handlePosition"
      :ok-title="position.id ? 'Mentés' : 'Létrehozás'"
      cancel-title="Mégse"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Új hajtás</h4>
        <a class="btn-close" @click="closeAddModal()"></a>
      </template>
      <form
        @submit.prevent="handlePosition()"
        ref="position_modal_form"
        v-if="loading == false"
      >
        <div class="form-group">
          <label class="form-label">Megnevezés:</label>
          <input
            class="form-control"
            :class="{ 'is-invalid': errors.name }"
            type="text"
            v-model="position.name"
            required
          />
          <div v-if="errors.name" class="invalid-feedback d-block">
            {{ errors.name[0] }}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Azonosító:</label>
          <input
            class="form-control"
            :class="{ 'is-invalid': errors.position_id }"
            type="text"
            v-model="position.position_id"
            required
          />
          <div v-if="errors.position_id" class="invalid-feedback d-block">
            {{ errors.position_id[0] }}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Feszültség:</label>
          <select
            class="form-select"
            v-model="position.operating_voltage"
            :class="{ 'is-invalid': errors.operating_voltage }"
          >
            <option
              v-for="(voltage, id) in operating_voltages"
              :value="voltage.value"
              :key="id"
            >
              {{ voltage.text }}
            </option>
          </select>
        </div>
        <div v-if="position.operating_voltage == 2">
          <div class="form-group">
            <label class="form-label">Állomás:</label>
            <input
              class="form-control"
              :class="{ 'is-invalid': errors.station }"
              type="text"
              v-model="position.station"
              required
            />
            <div v-if="errors.station" class="invalid-feedback d-block">
              {{ errors.station[0] }}
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Cellák:</label>
            <input
              class="form-control"
              :class="{ 'is-invalid': errors.cells }"
              type="text"
              v-model="position.cells"
              required
            />
            <div v-if="errors.cells" class="invalid-feedback d-block">
              {{ errors.cells[0] }}
            </div>
          </div>
        </div>
        <div class="form-group mt-2">
          <label class="form-label">Munkaterület:</label>
          <div class="input-group">
            <b-dropdown variant="primary">
              <template slot="button-content">
                <i class="py-0 fa fa-caret-down"></i>
              </template>
              <LocationDropdownRow
                v-for="(location, id) in locations"
                :key="id"
                :location="location"
                @location-selected="selectLocation"
              ></LocationDropdownRow>
            </b-dropdown>
            <input
              type="text"
              v-model="position.location_name"
              placeholder="Válassz"
              class="form-control"
              :class="{ 'is-invalid': errors.location_id }"
              disabled
            />
          </div>
          <div v-if="errors.location_id" class="invalid-feedback d-block">
            {{ errors.location_id[0] }}
          </div>
        </div>
        <button type="submit" class="d-none"></button>
      </form>
      <Loading v-else title="Létrehozás"></Loading>
    </b-modal>
    <panel title="Hajtások">
      <Loading v-if="positions === false" title="Hajtások betöltése"></Loading>
      <NoRecords
        v-if="positions.length == 0"
        main_icon="fas fa-user-lock"
        value="false"
        title="Nincsenek hajtások"
        subtitle="hozzon létre újat"
      ></NoRecords>
      <vue-good-table
        v-if="
          positions.length != 0 &&
          positions !== false &&
          locationslinear != false
        "
        :columns="columns"
        :rows="positions"
        :search-options="{ enabled: false, placeholder: 'Keresés...' }"
        :pagination-options="{
          enabled: true,
          position: 'bottom',
          firstLabel: 'Első Lap',
          lastLabel: 'Utolsó Lap',
          nextLabel: 'következő',
          prevLabel: 'előző',
          rowsPerPageLabel: 'Sor oldalanként',
          ofLabel: '/',
          allLabel: 'Összes',
          infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <button
              @click="editPosition(props.row.id)"
              class="btn btn-primary mx-1"
              title="szerkesztés"
            >
              <i class="fa fa-pen"></i>
            </button>
            <button
              @click="deletePosition(props.row.id)"
              class="btn btn-danger mx-1"
              title="törlés"
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
          <span v-else-if="props.column.field == 'locks'">
            <router-link
              :to="'/tasks/' + lock.task_id + '/edit'"
              v-for="(lock, id) in JSON.parse(props.row.locks)"
              :key="id"
            >
              <span class="fa-stack">
                <i
                  class="fa-solid fa-lock fa-stack-2x"
                  :class="{
                    'text-primary': lock.color == 1,
                    'text-black': lock.color == 4,
                    'text-red': lock.color == 3,
                  }"
                ></i>
                <i class="fa-solid fa-stack-1x text-white fs-11px mt-5px">{{
                  lock.name
                }}</i>
              </span>
            </router-link>
          </span>
          <span v-else-if="props.column.field == 'boxes'">
            <div v-for="(box, id) in props.row.boxes" :key="id">
              <div>
                {{ box.number + " - " + box.name }}
                <span
                  class="fa-stack"
                  v-if="
                    box.locks.find((l) => l.pivot.position_id == props.row.id)
                  "
                >
                  <i class="fa-solid fa-lock fa-stack-2x text-yellow"></i>
                  <i class="fa-solid fa-stack-1x text-black fs-9px mt-4px">{{
                    box.locks.find((l) => l.pivot.position_id == props.row.id)
                      .name
                  }}</i>
                </span>
              </div>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Confirmation from "../../apis/Confirmation";
import Position from "../../apis/Position";
import Location from "../../apis/Location";
import LocationDropdownRow from "../../components/LocationDropdownRow";

export default {
  components: {
    Loading,
    NoRecords,
    LocationDropdownRow,
  },
  data() {
    return {
      columns: [
        {
          label: "Azonosító",
          field: "position_id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az azonosítók között",
          },
        },
        {
          label: "Megnevezés",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Munkaterület",
          field: (row) => this.fieldLocation(row),
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a munkaterületek között",
          },
        },
        {
          label: "Feszültség",
          field: (row) => this.fieldVoltage(row),
        },
        {
          label: "Cellák",
          field: "cells",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a cellák között",
          },
        },
        {
          label: "Szekrények",
          field: "boxes",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Lakatok",
          field: "locks",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a lakatok között",
          },
        },
        {
          label: "Műveletek",
          field: "actions",
          sortable: false,
          thClass: "text-end buttons-wide-3",
          tdClass: "text-end buttons-wide-3",
          hidden: true,
        },
      ],
      operating_voltages: [
        { value: 0, text: "nincs" },
        { value: 1, text: "0,4 kV berendezés és műszerek" },
        { value: 2, text: "6,3 kV" },
      ],
      positions: false,
      locations: false,
      position: this.getDefaultPosition(),
      errors: [],
      loading: false,
    };
  },
  created() {
    Position.tableIndex().then((response) => {
      this.positions = response.data;
    });
    Location.index().then((response) => {
      this.locations = response.data;
    });
    if (this.user.role_id == 1) {
      this.$set(this.columns[7], "hidden", false);
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    locationslinear() {
      return this.$store.state.locationslinear;
    },
  },
  watch: {
    user: {
      handler(val) {
        if (val && val.role_id == 1) {
          this.$set(this.columns[7], "hidden", false);
        } else {
          this.$set(this.columns[7], "hidden", true);
        }
      },
      deep: true,
    },
  },
  methods: {
    fieldVoltage(rowObj) {
      return this.operating_voltages.find(
        (v) => v.value == rowObj.operating_voltage
      ).text;
    },
    fieldLocation(rowObj) {
      let a =
        this.locationslinear[
          this.locationslinear
            .map((location) => location.id)
            .indexOf(rowObj.location_id)
        ].name;
      console.log(a);
      return a;
    },
    getDefaultPosition() {
      return {
        name: "",
        position_id: "",
        operating_voltage: 0,
        station: "",
        cells: "",
        location_id: "",
      };
    },
    handlePosition(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      if (this.position.id) {
        console.log("update");
        this.updatePosition();
      } else {
        console.log("add");
        this.addPosition();
      }
    },
    editPosition(id) {
      this.position = JSON.parse(
        JSON.stringify(
          this.positions[this.positions.map((p) => p.id).indexOf(id)]
        )
      );
      this.position.location_name =
        this.locationslinear[
          this.locationslinear
            .map((l) => l.id)
            .indexOf(this.position.location_id)
        ].name;
      this.$bvModal.show("addPositionModal");
    },
    selectLocation(location) {
      this.$set(this.position, "location_id", location.id);
      this.$set(this.position, "location_name", location.name);
    },
    closeAddModal() {
      this.position = this.getDefaultPosition();
      this.errors = [];
      this.$bvModal.hide("addPositionModal");
    },
    addPosition() {
      Position.add(this.position)
        .then((response) => {
          this.positions.unshift(response.data);
          this.errors = [];
          this.closeAddModal();
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updatePosition() {
      Position.update(this.position.id, this.position)
        .then((response) => {
          let pid = this.positions.findIndex((e) => e.id == this.position.id);
          this.$set(this.positions, pid, response.data);
          this.errors = [];
          this.closeAddModal();
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deletePosition(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Position.delete(id)
            .then(() => {
              this.positions.splice(
                this.positions.map((position) => position.id).indexOf(id),
                1
              );
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style></style>
